/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { ExtendedWork } from './ExtendedWork';
const LTIAssignmentLaunchToOpenSubmissionParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('submission')],
    ['reason', /* #__PURE__ */ parsers.exactly('direct', 'latest')],
    ['submission', ExtendedWork],
]);
export class LTIAssignmentLaunchToOpenSubmission extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LTIAssignmentLaunchToOpenSubmissionParser.decode(input).map(res => new LTIAssignmentLaunchToOpenSubmission(res));
    }
    static unsafeDecode(input) {
        return LTIAssignmentLaunchToOpenSubmission.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LTIAssignmentLaunchToOpenSubmissionParser.encode(data);
    }
    static schema() {
        return LTIAssignmentLaunchToOpenSubmissionParser.schema();
    }
}
